import { render, staticRenderFns } from "./FormUsersConfig.vue?vue&type=template&id=94b26824&scoped=true"
import script from "./FormUsersConfig.vue?vue&type=script&lang=js"
export * from "./FormUsersConfig.vue?vue&type=script&lang=js"
import style0 from "./FormUsersConfig.vue?vue&type=style&index=0&id=94b26824&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94b26824",
  null
  
)

export default component.exports